import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Error from "src/shared/components/Error";
import contactProps from "src/shared/utilities/graphql/contactProps";

import useDealsByType from "../../utilities/hooks/useDealsByType";
import Table from "./Table";

const DealsTable = ({ contact, type }) => {
  const [pageOn, setPageOn] = useState(1);
  const dealsByType = useDealsByType({
    contact_id: contact.id,
    current_page: pageOn,
    type
  });

  const { dealsInfo, hasError, isLoading } = dealsByType;

  // reset page when switching between sales and rentals
  useEffect(() => {
    setPageOn(1);
  }, [type]);

  const handleChangePage = current => {
    setPageOn(current);
  };

  if (hasError) {
    return (
      <Error>
        There was an error loading this agent’s information, please try again
        later
      </Error>
    );
  }

  if (!isLoading && !dealsInfo.hasDeals()) {
    return <Error>There are no available deals for this agent</Error>;
  }

  return (
    <Table
      currentPage={pageOn}
      deals={dealsInfo.deals}
      isLoading={isLoading}
      onChange={handleChangePage}
      totalCount={dealsInfo.totalCount}
      totalPages={dealsInfo.totalPages}
    />
  );
};

DealsTable.propTypes = {
  contact: PropTypes.shape(contactProps).isRequired,
  type: PropTypes.string.isRequired
};

export default DealsTable;
